/**
 * @auth 赖传峰
 * @date 2022/9/28
 * http://wiki.xunlei.cn/pages/viewpage.action?pageId=96456207
 */
const category = 'web_official_website'

const actions = {
  /**
   * button：点击位置，introduction-PP介绍，mobile-app-手机APP，desktop-app-桌面应用程序, drive-网页版，browser-extension-浏览器扩展，help-使用帮助，faq-FAQ，contact-us-联系我们
   * TODO: 某些值跟官网路由保持一致
   */
  web_official_topbar_click(_: {
    button:
      | 'introduction'
      | 'mobile-app'
      | 'desktop-app'
      | 'drive'
      | 'browser-extension'
      | 'help'
      | 'faq'
      | 'contact-us';
  }) {},
  /**
   * 官网首页界面展示
   */
  web_official_main_page_show(_: {
    view:
      | 'try'
      | 'pic_loading'
      | 'pic_show'
      | 'pic_fail'
      | 'speed'
      | 'security'
      | 'hd'
      | 'platform'
      | 'price'
      | 'rating';
  }) {},
  /**
   * 官网首页界面点击
   * button：点击位置，install_app-安装 App，web_client-访问网页版
   */
  web_official_main_page_click(_: {
    button:
      | 'try_for_free'
      | 'speed_start'
      | 'security_start'
      | 'hd_start'
      | 'download_pc'
      | 'download_mac'
      | 'download_tv'
      | 'web_client'
      | 'go_extensions'
      | 'go_telegram'
      | 'go_mega'
      | 'go_pikpak'
      | 'go_google_drive'
      | 'get_sale'
      | 'input_click'
      | 'go_to_pikpak';
  }) {},
  /**
   * 手机APP界面展示
   */
  web_official_mobile_page_show() {},
  /**
   * 手机APP界面点击
   * button：点击位置，google-GP商店，app_store-Apple应用商店，apk-安装包，samsung-三星应用商店
   */
  web_official_mobile_page_click(_: { button: 'google' | 'app_store' | 'apk' | 'samsung' }) {},
  /**
   * 桌面应用程序界面展示
   */
  web_official_desktop_page_show() {},
  /**
   * 桌面应用程序界面点击
   * button：点击位置，web_client-访问网页版
   */
  web_official_desktop_page_click(_: { button: 'download_pc' | 'download_ms_pc' | 'web_client' | 'download_mac' }) {},
  /**
   * 浏览器扩展程序界面展示
   */
  web_official_extension_page_show() {},
  /**
   * 浏览器扩展程序界面点击
   * button：点击位置，chrome-Chrome浏览器，edge-Edge浏览器，offline_installation-离线安装
   */
  web_official_extension_page_click(_: { button: 'chrome' | 'edge' | 'offline' }) {},
  /**
   * 使用帮助界面展示
   */
  web_official_help_page_show() {},
  /**
   * 使用帮助界面点击
   * button：点击位置，copy-link 复制链接Tab，system-share 系统分享Tab，telegram-bot TG机器人TAB
   */
  web_official_help_page_click(_: { button: 'copy-link' | 'system-share' | 'telegram-bot' }) {},
  /**
   * FAQ界面展示
   */
  web_official_faq_page_show() {},
  /**
   * 联系我们界面点击
   * button：点击位置，support-用户支持邮箱按钮，business-商务合作邮箱按钮，copyright-版权举报链接
   */
  web_official_contact_page_click(_: { button: 'support' | 'business' | 'copyright' }) {},

  /**
   *  用户点击输入框时
   */
  web_official_input_click() {},

  /**
   *  用户点击示例链接时
   */
  web_official_demo_click(_: { type: 'Magnet' | 'Torrent' | 'TikTok' | 'X (Twitter)' | 'Facebook' }) {},

  /**
   *  用户点击 [try for free] 后得到结果后
   */
  web_official_input_result(_: { result: 'null' | 'fail' | 'pass' }) {},

  /**
   *  服务器解析完成后返回结果
   */
  web_official_loading_result(_: { result: 'pic_fail' | 'pic_show_new' | 'pic_show_old' }) {},

  /**
   *  用户点击 [立即保存]
   */
  web_official_save_click(_: { result: 'pic_fail' | 'pic_show_new' | 'pic_show_old' }) {},
  /**
   *  运营入口展示
   */
  web_official_activity_banner_show(_: { template: string }) {},
  /**
   *  运营入口点击
   */
  web_official_activity_banner_click(_: { template: string }) {},
  /**
   *  运营弹窗展示
   */
  web_official_activity_pop_show(_: { template: string, pop_rank: number }) {},
  /**
   *  运营弹窗点击
   */
  web_official_activity_pop_click(_: { template: string, item: number | 'close', pop_rank: number }) {},
  /**
   * TV界面展示
   */
  web_official_tv_page_show() {},
  /**
   * TV界面点击
   * button：点击位置，google-GP商店，apk-安装包，
   */
  web_official_tv_page_click(_: { button: 'google' | 'app_store' | 'apk' | 'samsung' }) {},

}
export default new Proxy(actions, {
  get(target, key: keyof typeof actions) {
    return (data = {} as Parameters<typeof target[typeof key]>[number]) => window.stat(category, key, data)
  },
})
